// import {
//   Avatar,
//   Box,
//   Chip,
//   Divider,
//   Grid,
//   Paper,
//   Typography,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import WSDataGridNew, {
//   IColumns,
// } from "../../../Components/DataGrid/WSDataGridNew";
// import { useNavigate, useParams } from "react-router-dom";
// import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

// export const AssignOrder: React.FC<any> = React.memo((props) => {
//    const params = useParams();
//     const id = params?.id;
    
//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { "Technician Management": "technician-management/list" },
//       {
//         [!id ? "Assign Order" : ""]: "/",
//       },
//     ]);
//   }, [id]);
//   const columns: IColumns[] = [
//     {
//       header: "Order ID",
//       fieldName: "",
//       type: "default",
//       // sortable: true
//     },
//     {
//       header: "Date",
//       fieldName: "price",
//       type: "default",
//     },
//     {
//       header: "Patient Name",
//       fieldName: "mode",
//       type: "default",
//     },
//     {
//       header: "Products",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Address",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Status",
//       fieldName: "status",
//       type: "status",
//     },

//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit"].filter(Boolean),
//       // actionCallback: (action, row) => handleAction(action, row),
//       // hideSelectedActions: {
//       //     fieldToHide: [
//       //         {
//       //             field: 'status',
//       //             hideValue: ['Incomplete'],
//       //             hideActions: ['Edit']
//       //         },
//       //         // {
//       //         //     field: 'profileStatus',
//       //         //     hideValue: ['Approved'],
//       //         //     hideActions: ['Approve']
//       //         // }
//       //     ]
//       // }
//     },
//   ];
//   const filterRows: IHeaderRows[] = [
//     {
//       label: "By Date",
//       fieldName: "",
//       type: "date",
//       operator: "like",
//       rowDivision: 6,
//     },
//   ];
//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url={"/technician-management/list"} />
//       <Paper
//         sx={{
//           mb: 3,
//           mt:2,
//           p: 2,
//           display: "flex",
//           flexDirection: "column",
//           gap: 2, // spacing between heading and content
//         }}
//       >
//         {/* Heading + Underline */}
//         <Grid>
//           <Typography
//             variant="h6"
//             fontWeight={600}
//             sx={{ color: "#1A1A1A", mb: 0.5 }}
//           >
//             Carrier Partner
//           </Typography>

//           <Divider />
//         </Grid>

//         {/* Content Row */}
//         <Grid
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <Grid sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <Avatar src="" sx={{ width: 56, height: 56 }} />
//             <Grid>
//               <Typography fontWeight={600}>David Miller</Typography>
//               <Typography variant="body2" color="gray">
//                 ID : PHD1023
//               </Typography>
//               <Typography variant="body2" color="gray">
//                 3 yrs Exp.
//               </Typography>
//             </Grid>
//           </Grid>

//           <Chip
//             label="Active"
//             color="success"
//             size="small"
//             sx={{
//               backgroundColor: "#CEEEE5",
//               color: "#098963",
//             }}
//           />
//         </Grid>
//       </Paper>
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 20,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2}>
//           <Grid item sm={12} xs={12}>
//             <WSDataGridNew
//               columns={columns}
//               id="vendorProductListGrid"
//               title="Products"
//               exportCsv={true}
//               filterFields={filterRows}
//               addButton={{ label: "New", color: "secondary" }}
//               searchBox={{ fieldName: "name,id,task,package" }}
//               gridHeaderSx={{
//                 backgroundColor: "whitesmoke",
//                 border: "1px solid whitesmoke",
//               }}
//             />
//           </Grid>
//         </Grid>
//       </Paper>
//     </>
//   );
// });






// import {
//   Avatar,
//   Box,
//   Chip,
//   Divider,
//   Grid,
//   Paper,
//   Typography,
// } from "@mui/material";
// import React, { useEffect, useState, useCallback } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import http from "../../../commonFunctions/httpClient";
// import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import WSDataGridNew, {
//   IColumns,
// } from "../../../Components/DataGrid/WSDataGridNew";
// import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";

// interface AssignOrderData {
//   id: string;
//   orderId: string;
//   date: string;
//   patientName: string;
//   products: number;
//   address: string;
//   status: string;
//   deliveryPersonId: string;
// }

// export const AssignOrder: React.FC<any> = React.memo((props) => {
//   const params = useParams();
//   const navigate = useNavigate();
//   const vendorId = params?.id || "";

//   const [carrierData, setCarrierData] = useState<any>({
//     name: "David Miller",
//     id: "PHD1023",
//     experience: "3 yrs Exp.",
//     status: "Active"
//   });
//   const [orders, setOrders] = useState<AssignOrderData[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [debugInfo, setDebugInfo] = useState<any>({});

//   // Update breadcrumbs
//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { "Technician Management": "technician-management/list" },
//       { "Assign Order": `/assign-order/${vendorId}` },
//     ]);
//   }, [vendorId]);

//   // ✅ FIXED: Exact API endpoints from your spec
//   const fetchOrders = useCallback(async () => {
//     if (!vendorId) {
//       console.log("❌ NO VENDOR ID - URL:", window.location.href);
//       setDebugInfo({ vendorId: "MISSING", status: "No vendor ID in URL" });
//       setLoading(false);
//       return;
//     }
//     console.log("vendorid",vendorId);

//     try {
//       setLoading(true);
//       console.log("📡 FETCHING ORDERS →", `pharmacy/ph_order_/By_Vendor/${vendorId}`);
      
//       // ✅ CORRECTED: Matches your original spec EXACTLY
//       const response: any = await http.get(`pharmacy/ph_order_/By_Vendor/${vendorId}`);
      
//       console.log("✅ FULL API RESPONSE:", response);
//       console.log("📦 response.data:", response.data);
      
//       let data: AssignOrderData[] = [];
      
//       if (response?.data) {
//         const apiData = Array.isArray(response.data) ? response.data : 
//                        response.data.data || response.data.items || [];
        
//         console.log("🔍 API DATA STRUCTURE:", apiData);
        
//         if (apiData.length > 0) {
//           data = apiData.map((order: any, index: number) => {
//             console.log(`🔍 ORDER ${index}:`, order);
//             return {
//               id: order.id || order.orderId || `order-${index}`,
//               orderId: order.orderId || order.orderNumber || order.id || `ORD-${index}`,
//               date: order.orderDate || order.createdAt || new Date().toISOString().split('T')[0],
//               patientName: order.userName || order.patientName || order.customerName || "N/A",
//               products: order.itemCount || order.itemsCount || order.items?.length || 0,
//               address: order.address || order.deliveryAddress || order.location || "N/A",
//               status: order.status || "Pending",
//               deliveryPersonId: vendorId
//             };
//           });
//         }
//       }
      
//       console.log("📦 FINAL DATA:", data);
//       setOrders(data);
//       setDebugInfo({
//         vendorId,
//         fullUrl: window.location.href,
//         apiCalled: `pharmacy/ph_order_/By_Vendor/${vendorId}`,
//         apiResponse: response?.data ? `${(Array.isArray(response.data) ? response.data.length : 0)} items` : "Empty",
//         processedCount: data.length,
//         status: data.length > 0 ? "✅ SUCCESS" : "⚠️ NO DATA"
//       });
      
//     } catch (error: any) {
//       console.error("💥 API ERROR:", error);
//       console.error("💥 FULL ERROR:", error.response);
//       setOrders([]);
//       setDebugInfo({
//         vendorId,
//         error: error.message,
//         statusCode: error.response?.status,
//         apiCalled: `pharmacy/ph_order_/By_Vendor/${vendorId}`,
//         status: "❌ ERROR"
//       });
//     } finally {
//       setLoading(false);
//     }
//   }, [vendorId]);

//   useEffect(() => {
//     fetchOrders();
//   }, [fetchOrders]);

//   const handleAssignOrder = async (action: string, row: AssignOrderData) => {
//     if (action === "Assign") {
//       try {
//         const assignPayload = {
//           orderId: row.orderId,
//           deliveryPersonId: vendorId,
//           assignedAt: new Date().toISOString()
//         };

//         console.log("📤 ASSIGNING →", `pharmacy/DeliveryPerson/assign`, assignPayload);
        
//         // ✅ CORRECTED: Matches your original spec EXACTLY
//         const response = await http.post("pharmacy/DeliveryPerson/assign", assignPayload);
//         console.log("✅ ASSIGN SUCCESS:", response);

//         fetchOrders();
//         alert(`Order ${row.orderId} assigned successfully!`);
//       } catch (error: any) {
//         console.error("❌ ASSIGN ERROR:", error);
//         alert("Failed to assign order.");
//       }
//     }
//   };

//   const columns: IColumns[] = [
//     { header: "Order ID", fieldName: "orderId", type: "default" },
//     { header: "Date", fieldName: "date", type: "default" },
//     { header: "Patient Name", fieldName: "patientName", type: "default" },
//     { header: "Products", fieldName: "products", type: "default" },
//     { header: "Address", fieldName: "address", type: "default" },
//     { header: "Status", fieldName: "status", type: "status" },
//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Assign"],
//       actionCallback: (action, row) => handleAssignOrder(action, row),
//     },
//   ];

//   const filterRows: IHeaderRows[] = [
//     {
//       label: "Status",
//       fieldName: "status",
//       type: "dropdown",
//       options: [{ label: "All", value: "" }, { label: "Pending", value: "Pending" }, { label: "Assigned", value: "Assigned" }],
//       operator: "eq",
//       rowDivision: 3,
//     },
//     {
//       label: "By Date",
//       fieldName: "date",
//       type: "date",
//       operator: "gte",
//       rowDivision: 6,
//     },
//   ];

//   if (loading) {
//     return (
//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
//           <div>Loading orders for carrier <strong>{vendorId}</strong>...</div>
//         </Grid>
//       </Grid>
//     );
//   }

//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url="/technician-management/list" />
      
//       <Paper sx={{ mb: 3, mt: 2, p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
//         <Grid>
//           <Typography variant="h6" fontWeight={600} sx={{ color: "#1A1A1A", mb: 0.5 }}>
//             Carrier Partner - <strong>{vendorId}</strong>
//           </Typography>
//           <Divider />
//         </Grid>
//         <Grid sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//           <Grid sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <Avatar src="" sx={{ width: 56, height: 56 }} />
//             <Grid>
//               <Typography fontWeight={600}>{carrierData.name}</Typography>
//               <Typography variant="body2" color="gray">ID: {vendorId}</Typography>
//               <Typography variant="body2" color="gray">{carrierData.experience}</Typography>
//             </Grid>
//           </Grid>
//           <Chip label={carrierData.status} color="success" size="small" sx={{ backgroundColor: "#CEEEE5", color: "#098963" }} />
//         </Grid>
//       </Paper>

//       <Paper elevation={0} sx={{ p: 3, mt: 2, borderRadius: "8px" }}>
//         <Grid container spacing={2}>
//           <Grid item sm={12} xs={12}>
//             <WSDataGridNew
//               columns={columns}
//               id="assignOrderGrid"
//               title={`Orders Available for Assignment (${orders.length})`}
//               exportCsv={true}
//               filterFields={filterRows}
//               data={orders}
//               searchBox={{ fieldName: "orderId,patientName" }}
//               gridHeaderSx={{ backgroundColor: "whitesmoke", border: "1px solid whitesmoke" }}
//             />
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* 🆕 DEBUG PANEL */}
//       <Paper sx={{ mt: 3, p: 3, backgroundColor: '#fff3e0' }}>
//         <Typography variant="h6" color="warning.main" gutterBottom>🔍 DEBUG INFO</Typography>
//         <Box sx={{ fontSize: '0.9rem' }}>
//           <div><strong>URL:</strong> {debugInfo.fullUrl || window.location.href}</div>
//           <div><strong>Vendor ID:</strong> <span style={{color: debugInfo.vendorId ? 'green' : 'red'}}>{debugInfo.vendorId || 'MISSING'}</span></div>
//           <div><strong>API Called:</strong> {debugInfo.apiCalled}</div>
//           <div><strong>Orders Loaded:</strong> <span style={{color: orders.length > 0 ? 'green' : 'red'}}>{orders.length}</span></div>
//           <div><strong>Status:</strong> <span style={{fontWeight: 'bold'}}>{debugInfo.status}</span></div>
//           {debugInfo.error && (
//             <div style={{color: 'red', fontWeight: 'bold'}}>
//               <strong>ERROR:</strong> {debugInfo.error} {debugInfo.statusCode && `(Code: ${debugInfo.statusCode})`}
//             </div>
//           )}
//         </Box>
//         <button 
//           onClick={fetchOrders}
//           style={{
//             marginTop: 10, padding: '8px 16px', backgroundColor: '#1976d2', 
//             color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer'
//           }}
//         >
//           🔄 Refresh Orders
//         </button>
//       </Paper>
//     </>
//   );
// });









import {
  Avatar,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSBackButton from "../../../Components/BackButton/BackButton";
import WSDataGridNew, {
  IColumns,
} from "../../../Components/DataGrid/WSDataGridNew";
import { useNavigate, useParams } from "react-router-dom";
import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import http from "../../../commonFunctions/httpClient";
import {
  getLocalValue,
  LoacalVariables,
} from "../../../commonFunctions/CommonFunctions";

interface AssignOrderRow {
  backendOrderId: string;   // this is what backend expects as ph_OrderId

  id: string;               // row key for grid
  orderId: string;          // visible order id column
  date: string;
  patientName: string;
  products: string;
  address: string;
  status: string;
  actions: string;
}

interface TechnicianProfile {
  name: string;
  id: string;
  experience: string;
  profileImage?: string;
  status: string;
}

export const AssignOrder: React.FC<any> = React.memo(() => {
  const params = useParams();
  const id = params?.id; // technician id (deliveryPersonId)
  const navigate = useNavigate();

  const [vendorId, setVendorId] = useState<string>("");
  const [orders, setOrders] = useState<AssignOrderRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [apiLoading, setApiLoading] = useState<Set<string>>(new Set());
  const [technicianProfile, setTechnicianProfile] =
    useState<TechnicianProfile | null>(null);
  const [technicianLoading, setTechnicianLoading] = useState(true);
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
  }>({
    open: false,
    message: "",
    severity: "success",
  });

  // vendor ID
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    setVendorId(userId || "");
  }, []);

  // map API -> grid rows
  const mapOrdersFromResponse = (responseData: any[]): AssignOrderRow[] => {
    return responseData.map((order: any) => {
      const formatAddress = (address: any) => {
        if (!address) return "N/A";
        const parts: string[] = [];
        if (address.addressLine1) parts.push(address.addressLine1);
        if (address.addressLine2) parts.push(address.addressLine2);
        if (address.pincode) parts.push(address.pincode);
        return parts.join(", ") || "N/A";
      };

      // IMPORTANT: this must match what you send as ph_OrderId
      // If your list response has ph_OrderId, use that directly.
      const backendOrderId: string =
        order.ph_OrderId ||         // preferred if present
        order.pharmacyOrderId ||    // or whatever field backend uses
        order.orderId ||
        order.orderNumber ||
        order.id ||
        "";

      return {
        backendOrderId,
        id: backendOrderId,
        orderId: backendOrderId,
        date: order.orderDate || "N/A",
        patientName: order.userName || order.patientName || "Unknown",
        products: (
          order.itemCount ||
          order.products?.length ||
          0
        ).toString(),
        status: (order.status || "Pending").toString(),
        address: formatAddress(order.address),
        actions: backendOrderId,
      };
    });
  };

  const fetchOrders = useCallback(
    async (showLoading = true) => {
      if (!vendorId) {
        if (showLoading) setLoading(false);
        return;
      }

      try {
        if (showLoading) setLoading(true);

        const response: any = await http.get(
          `/pharmacy/Ph_Order_/AssignedOrPlaced/${vendorId}`
        );

        if (response?.success && Array.isArray(response.data)) {
          const mapped = mapOrdersFromResponse(response.data);
          setOrders(mapped);
        } else {
          setOrders([]);
        }
      } catch (error: any) {
        console.error("Fetch orders error:", error);
        setOrders([]);
      } finally {
        if (showLoading) setLoading(false);
      }
    },
    [vendorId]
  );

  const handleAssignToggle = useCallback(
    async (backendOrderId: string) => {
      console.log("handleAssignToggle called with:", backendOrderId);
      console.log("Current orders:", orders);

      if (!id) {
        setSnackbar({
          open: true,
          message: "Missing technician ID",
          severity: "error",
        });
        return;
      }

      const currentOrder = orders.find(
        (o) => o.backendOrderId === backendOrderId
      );

      if (!currentOrder) {
        console.error("Order not found in local state, id:", backendOrderId);
        setSnackbar({
          open: true,
          message: "Order not found locally",
          severity: "error",
        });
        return;
      }

      setApiLoading((prev) => {
        const s = new Set(prev);
        s.add(backendOrderId);
        return s;
      });

      try {
        // MATCHES your Postman body:
        // {
        //   "deliveryPersonId": "...",
        //   "ph_OrderId": "..."
        // }
        const payload = {
          deliveryPersonId: id,
          ph_OrderId: backendOrderId,
        };

        console.log("Assign payload:", payload);

        const response: any = await http.post(
          "/pharmacy/DeliveryPerson/assign",
          payload
        );

        if (response?.success === false) {
          throw new Error(response?.message || "API failed");
        }

        await fetchOrders(false);

        setOrders((prev) => {
          const updatedOrder = prev.find(
            (o) => o.backendOrderId === backendOrderId
          );
          const newStatus = updatedOrder?.status || currentOrder.status;

          setSnackbar({
            open: true,
            message:
              newStatus === "Assigned"
                ? "Order assigned successfully ✅"
                : newStatus === "Pending"
                ? "Order unassigned successfully ✅"
                : "Order updated successfully ✅",
            severity: "success",
          });

          return prev;
        });
      } catch (error: any) {
        console.error("Assign Error full:", error);

        const errorMsg =
          error?.response?.data?.message ||
          (error?.response?.status === 404
            ? "Order not found on server"
            : "Failed to update order");

        setSnackbar({ open: true, message: errorMsg, severity: "error" });
      } finally {
        setApiLoading((prev) => {
          const s = new Set(prev);
          s.delete(backendOrderId);
          return s;
        });
      }
    },
    [id, orders, fetchOrders]
  );

  useEffect(() => {
    const fetchTechnicianProfile = async () => {
      if (!id || !vendorId) {
        setTechnicianLoading(false);
        return;
      }

      try {
        setTechnicianLoading(true);
        const response: any = await http.get(
          `/pharmacy/DeliveryPerson/${vendorId}/delivery-person`
        );

        if (response?.success && Array.isArray(response.data)) {
          const technician = response.data.find(
            (t: any) => t.technicianId === id
          );
          if (technician) {
            setTechnicianProfile({
              name: technician.name || technician.profileName || "Unknown",
              id: technician.technicianId || id,
              experience: `${technician.experience || 0} yrs`,
              profileImage: technician.profileImage
                ? `https://melpapi.reobeen.com${technician.profileImage}`
                : undefined,
              status: technician.status || "Active",
            });
          }
        }
      } catch (error) {
        console.error("Profile error:", error);
      } finally {
        setTechnicianLoading(false);
      }
    };

    fetchTechnicianProfile();
  }, [id, vendorId]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  useEffect(() => {
    breadCrumbsStore.updateBreadCrumbs([
      { "Technician Management": "technician-management/list" },
      { "Assign Order": `/technician-management/assign/${id}` },
    ]);
  }, [id]);

  const columns: IColumns[] = [
    { header: "Order ID", fieldName: "orderId", type: "default" },
    { header: "Date", fieldName: "date", type: "date" },
    { header: "Patient Name", fieldName: "patientName", type: "default" },
    { header: "Products", fieldName: "products", type: "default" },
    { header: "Address", fieldName: "address", type: "default" },
    { header: "Status", fieldName: "status", type: "status" },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Assign"],
      actionCallback: (action: string, row: AssignOrderRow) => {
        if (action === "Assign") {
          console.log("Action row ===>", row);
          handleAssignToggle(row.backendOrderId);
        }
      },
    },
  ];

  const filterRows: IHeaderRows[] = [
    {
      label: "By Date",
      fieldName: "date",
      type: "date",
      operator: "gte",
      rowDivision: 6,
    },
    {
      label: "Status",
      fieldName: "status",
      type: "dropdown",
      options: [
        { label: "All", value: "" },
        { label: "Pending", value: "Pending" },
        { label: "Assigned", value: "Assigned" },
      ],
      operator: "eq",
      rowDivision: 3,
    },
  ];

  const handleSnackbarClose = () => {
    setSnackbar({ open: false, message: "", severity: "success" });
  };

  if (loading) {
    return (
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid
          item
          sm={12}
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="400px"
        >
          <div>Loading orders...</div>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <WSBackButton id="btnScheduleBack" url={"/technician-management/list"} />

      {/* Technician Profile */}
      <Paper
        sx={{
          mb: 3,
          mt: 2,
          p: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Grid>
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{ color: "#1A1A1A", mb: 0.5 }}
          >
            Carrier Partner
          </Typography>
          <Divider />
        </Grid>
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Grid sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar
              src={
                technicianLoading ? undefined : technicianProfile?.profileImage
              }
              sx={{
                width: 56,
                height: 56,
                bgcolor: technicianLoading ? "grey.300" : "primary.main",
              }}
            >
              {technicianLoading ? (
                <CircularProgress size={24} color="inherit" thickness={5} />
              ) : (
                technicianProfile?.name?.charAt(0)?.toUpperCase() || "T"
              )}
            </Avatar>
            <Grid>
              <Typography fontWeight={600}>
                {technicianLoading
                  ? "Loading..."
                  : technicianProfile?.name || "Unknown"}
              </Typography>
              <Typography variant="body2" color="gray">
                ID:{" "}
                {technicianLoading
                  ? "Loading..."
                  : technicianProfile?.id || id}
              </Typography>
              <Typography variant="body2" color="gray">
                {technicianLoading
                  ? "Loading..."
                  : technicianProfile?.experience}
              </Typography>
            </Grid>
          </Grid>
          <Chip
            label={
              technicianLoading
                ? "Loading..."
                : technicianProfile?.status || "Active"
            }
            color={
              technicianLoading
                ? "default"
                : technicianProfile?.status === "Active"
                ? "success"
                : "default"
            }
            size="small"
          />
        </Grid>
      </Paper>

      {/* Orders Grid */}
      <Paper
        elevation={0}
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          marginTop: 20,
          paddingBottom: 25,
          borderRadius: "8px",
        }}
      >
        <Grid container spacing={2}>
          <Grid item sm={12} xs={12}>
            <WSDataGridNew
              columns={columns}
              id="assignOrderListGrid"
              title={`Assign Orders - Vendor ${vendorId.substring(
                0,
                8
              )}... (${orders.length})`}
              exportCsv={true}
              filterFields={filterRows}
              data={orders}
              searchBox={{ fieldName: "patientName" }}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
});

export default AssignOrder;
